<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="detailTabs"
                        activeKey="basic_info">
                    <template slot="gofixTab:right">
                        <gofix-button
                            class="mr-3"
                            :loading="disabled"
                            label="Save"
                            @click="save"></gofix-button>
                        <gofix-button
                            outline
                            label="Logout"
                            @click="logout"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic_info">
                        <gofix-card>
                            <b-row class="mt-4">
                                <b-col md="3">
                                    <gofix-form-input label="User Name" v-model="$v.userProfile.name.$model" autocomplete="off" required></gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="3">
                                    <gofix-form-input label="Password" type="password" v-model="$v.userProfile.password.$model" autocomplete="new-password">
                                        <template slot="gofixInput:text:after-desc">
                                            <p class="desc">
                                                <small v-if="$v.userProfile.repassword.$error" class="clear-small label-error">Password doesn’t match</small>
                                            </p>
                                        </template>
                                    </gofix-form-input>
                                </b-col>
                                <b-col md="3">
                                    <gofix-form-input label="Confirm Password" type="password" v-model="$v.userProfile.repassword.$model" autocomplete="new-password">
                                        <template slot="gofixInput:text:after-desc">
                                            <p class="desc">
                                                <small v-if="$v.userProfile.repassword.$error" class="clear-small label-error">Password doesn’t match</small>
                                            </p>
                                        </template>
                                    </gofix-form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4" class="custom-cases gofixLogoContract gofixSignature">
                                    <gofix-text-field label="Signature" class="editPhotoValue" classLabel="font-14" classValue="pl-0" classInner="d-block" oneline>
                                        <div class="d-flex align-items-center viewer mt-11">
                                            <template v-if="userProfile.signature_image">
                                                <viewer-image :images="userProfile.signature_image" classViewer='d-flex align-items-center'>
                                                    <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                        <ul class="list-thumb list-unstyled max-width-per-100 mb-0">
                                                            <li class="mb-0 mr-10" v-for="(item, key) in images" v-bind:key="key">
                                                                <img v-auth-image="item.url.original" :alt="item.image_file_name || 'image'"  src="img/loading.gif">
                                                            </li>
                                                        </ul>
                                                    </template>    
                                                </viewer-image>
                                            </template>
                                            <div class="upload-btn-wrapper m-0">
                                                <b-form-file v-model="attachmentFile" accept=".jpg, .png, .gif" plain></b-form-file>
                                                <gofix-button :label="!userProfile.signature_image || !userProfile.signature_image.length ? 'ADD PHOTO' : 'CHANGE PHOTO'" outline></gofix-button>
                                            </div>
                                        </div>
                                    </gofix-text-field>
                                </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card>
                            <b-row class="mt-4">
                                <b-col md="4">
                                    <gofix-text-field classLabel="width-70" label="Company" oneline>{{  userProfile.organization && userProfile.organization.name ? userProfile.organization.name : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field classLabel="width-120" label="Department" oneline>{{ userProfile.department ? userProfile.department : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field label="Disabled" oneline>{{ userProfile.active == true ? 'Off' : 'On' }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4">
                                <b-col md="4">
                                    <gofix-text-field classLabel="width-70" label="Email" oneline>{{ userProfile.email ? userProfile.email : '' }}</gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field classLabel="width-120" label="Email verified At" oneline>{{ userProfile.email_verified_at ? userProfile.email_verified_at : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field label="Preferred Mode of Contact" oneline>{{ userProfile.preferred_contact_mode ? userProfile.preferred_contact_mode : '' }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4">
                                <b-col md="4">
                                    <gofix-text-field classLabel="width-70" label="Role" oneline>
                                        <template v-if="userProfile.roles">
                                            <template v-for="(item, index) in userProfile.roles">
                                                <span :key="index">
                                                    {{ `${item.name} ${index != (userProfile.roles.length - 1) ? ', ' : ''}` }}
                                                </span>
                                            </template>
                                        </template>
                                    </gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field label="Last Login At" oneline>{{ userProfile.last_login ? userProfile.last_login : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                </b-col>
                                <b-col md="4">
                                    <gofix-text-field label="Last IP Address" oneline>{{ userProfile.ip ? userProfile.ip : '' }}</gofix-text-field>
                                </b-col>
                            </b-row>
                            <b-row class="mt-4">
                              <b-col md="4">
                                <gofix-text-field v-if="!userProfile.mfa_required" label="Require MS OTP Authentication" oneline>
                                    <b-form-checkbox @change="msAuthentication" :value="true" v-model="userProfile.microsoft2fa_enable" :unchecked-value="false" switch>
                                    </b-form-checkbox>
                                    
                                    <!--<c-switch color="success" label variant="pill" size="sm" class="float-right" checked />-->
                                </gofix-text-field>
                                <gofix-text-field v-else label="MS OTP Authentication" oneline>{{ userProfile.microsoft2fa_enable ? 'On' : 'Off' }}</gofix-text-field>
                                </b-col>
                              <b-col md="4">
                                <gofix-button label="See last 10 logins" @click="modals.last_login.open = true"></gofix-button>
                              </b-col>
                            </b-row>
                        </gofix-card>
                        <gofix-card title="Address" classContent="mb-0">
                            <b-row v-if="userProfile.address">
                                <template v-for="(item, index) in userProfile.address">
                                    <b-col class="mb-3" cols="12" :key="index">
                                        <gofix-card title=" " class="h-100 pd-15" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                                            <b-row>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="Salutation" oneline>{{ item.salutation ? item.salutation : '' }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="First Name" oneline>{{ item.first_name ? item.first_name : null }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-165" label="Last Name" oneline>{{ item.last_name ? item.last_name : '' }}</gofix-text-field>
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-4">
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="Address" oneline>{{ item.display_address ? item.display_address : '' }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="Mobile Phone" oneline>{{ item.primary_phone ? item.primary_phone : null }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-165" label="Mobile Phone Verified" oneline>{{ item.phone_verified ? "Yes" : "No" }}</gofix-text-field>
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-4">
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="Second Phone" oneline>{{ item.secondary_phone ? item.secondary_phone : '' }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="8">
                                                    <gofix-text-field classLabel="width-110" label="Email Address" oneline>{{ item.email ? item.email : '' }}</gofix-text-field>
                                                </b-col>
                                            </b-row>
                                            <b-row class="mt-4">
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="Email Verified" oneline>{{ item.email_verified ? "Yes" : "No" }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-110" label="Default Mailing" oneline>{{ item.mailing_address_id ? "Yes" : "No" }}</gofix-text-field>
                                                </b-col>
                                                <b-col md="4">
                                                    <gofix-text-field classLabel="width-165" label="Default Billing" oneline>{{ item.billing_address_id ? "Yes" : "No" }}</gofix-text-field>
                                                </b-col>
                                            </b-row>
                                        </gofix-card>
                                    </b-col>
                                </template>
                            </b-row>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Check-User" :title="modals.last_login.title" hide-footer :centered="true" v-model="modals.last_login.open" ref="modal-check">
        <div class="pl-10 pr-10">
          <ul class="list-unstyled list-client" v-if="login_histories" v-bind:class="{'run-loading':modals.last_login.loading}">
            <template v-for="(item, index) in login_histories">
              <li v-bind:key="item.id">
                <p>
                  IP: {{ item.ip }}
                  <small>Email: {{ item.email }}</small>
                  <small>Description: {{ item.description }}</small>
                  <small>Login at: {{ item.login_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                  <small>Logout at: {{ item.logout_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                  <small>Bowse engine: {{ item.browse_engine}}</small>
                </p>
              </li>
            </template>
          </ul>
        </div>
      </b-modal>
        <b-toast id="toast-custom1" variant="danger" solid>
            <template #toast-title>
                <div class="d-flex flex-grow-1 align-items-baseline">
                <strong class="mr-auto">Notification</strong>
                </div>
            </template>
            <div class="err-pwd-toast" v-if="errorMessage">
                <div v-html="errorMessage"></div>
            </div>
        </b-toast>
        <b-modal :no-close-on-backdrop="true" 
            :no-close-on-esc="true"
            hide-footer
            @hidden="resetModal"
            modal-class="modal-2fa"
            id="modal-Create-Check-User" 
            :title="modals.twofa.title" 
            :centered="true" 
            v-model="modals.twofa.open" 
            :hide-header-close="true"
            ref="modal-check">
            <div v-bind:class="{'run-loading':loading}" >
                <div class="pl-10 pr-10" v-if="modals.step1">
                    <div class="twofa-text">
                        <div class="twofa-img">
                            <img src="img/icon_method_generator.png">
                        </div>
                        <div class="twofa-txt">
                            <strong>Setup via Third-Party Validator</strong>
                            <p>Please use your authenticator app (Microsoft Authenticator) to scan this QR code.</p>
                        </div>
                    </div>
                    <div class="qrcode">
                        <b-row>
                            <b-col md="6">
                                <div class="b-qr">
                                    <img alt="" :src="modals.twofa.data.qrcode">
                                </div>
                            </b-col>
                            <b-col md="6">
                                <div class="secret-box">
                                    <span>Or enter this code in your authenticator app</span>
                                    <div class="key">{{ modals.twofa.data.secret }}</div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div v-if="modals.step2" class="item">
                    <div class="m-title">Enter the confirmation code</div>
                    <div class="m-content">
                        Please enter the verification code you see on your authenticator app
                    </div>
                    <div class="m-form">
                        <b-form class="form-vertical login-form formV2 text-center" autocomplete="off">
                            <div class="six-number">
                                <masked-input v-for="(val, el) in codeArr"
                                    :key="el"
                                    type="text"
                                    @keyup="focusNext"
                                    v-model="codeArr[el]"
                                    :mask="mask"
                                    :guide="false"
                                    placeholderChar="#"
                                    v-on:blur="blurInput = true">
                                </masked-input>
                            </div>
                        </b-form>
                    </div>
                </div>
                <div v-if="modals.step3" class="mg-success">
                    <div class="twofa-text">
                        <div class="twofa-img">
                            <img src="img/icon_success_small.png">
                        </div>
                        <div class="twofa-txt">
                            <strong>Two-factor authentication is on</strong>
                        </div>
                    </div>
                </div>
                <div class="actions">
                    <b-button-group class="d-block text-right">
                        <gofix-button v-if="modals.step1" label="CANCEL" @click="close2FA" noBorder dark></gofix-button>
                        <gofix-button :loading="modals.twofa.loading" @click="continueStep" v-if="modals.step1" label="CONTINUE" noBorder></gofix-button>
                        <gofix-button :loading="modals.twofa.loading" @click="verifyCode" v-if="modals.step2" label="CONTINUE" noBorder></gofix-button>
                        <gofix-button :loading="modals.twofa.loading" @click="done" v-if="modals.step3" label="DONE" noBorder></gofix-button>
                    </b-button-group>
                </div>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="Two-factor authentication" hide-footer hide-header :centered="true" v-model="modals.twofaConfirm.open">
            <div class="center">Are you sure you want to<br/>turn off <strong>2fa</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="cancelDisableTwoFA">No</b-button>
                <b-button class="custom-btn" @click="disableTwoFA">Yes</b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" 
            hide-footer
            @hidden="resetModalPW"
            modal-class="modal-off-2fa"
            id="modal-Create-Check-User" 
            :title="modals.twofa.title" 
            :centered="true" 
            v-model="modals.twofaOff.open" 
            ref="modal-check">
            <div v-bind:class="{'run-loading':loading}" >
                <div class="item">
                    <div class="m-title">Enter your password</div>
                    <div class="m-content">
                        Please enter your password to continue
                    </div>
                    <div class="m-form">
                        <b-form class="form-vertical login-form formV2 text-center" autocomplete="off">
                            <gofix-form-input label="Password" type="password" v-model="modals.twofaOff.password" ></gofix-form-input>
                        </b-form>
                    </div>
                </div>
                <div class="actions">
                    <b-button-group class="d-block text-right">
                        <gofix-button :loading="modals.twofaOff.loading" @click="submitDisableTwoFA" label="SUBMIT" noBorder></gofix-button>
                    </b-button-group>
                </div>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="Two-factor authentication" hide-footer hide-header :centered="true" v-model="modals.cancel2FA.open">
            <div class="center">You <strong>2fa</strong> setup has not finished? <br/> Do you want to cancel the setup?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.cancel2FA.open = false">No</b-button>
                <b-button class="custom-btn" @click="cancelSetup2FA">Yes</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { validationMixin } from 'vuelidate'
    import { required, sameAs} from 'vuelidate/lib/validators'
    const ViewerImage = () => import('../plugins/ViewerImage.vue')
    import { Switch as cSwitch } from '@coreui/vue'
    import createNumberMask from 'text-mask-addons/dist/createNumberMask';
    
    export default {
        name: 'user-info',
        components: {
            ViewerImage,
            cSwitch
        },
        data () {
            return {
                detailTabs:[
                    {
                        key: "basic_info",
                        title: "basic info",
                        active: true,
                    },
                ],
                userProfile: {
                    name: null,
                    password: null,
                    repassword: null,
                },
                enable_2fa:false,
                disabled: false,
                errorMessage:null,
                modals:{
                    step1:true,
                    step2:false,
                    step3:false,
                    last_login:{
                    open:false,
                    loading:false,
                    title:"Latest login",
                    },
                    twofa:{
                        qrCode:null,
                        open:false,
                        title:'Two-factor authentication',
                        data:{
                            qrcode:null,
                            secret: null
                        }
                    },
                    twofaConfirm:{
                        open:false,
                        loading:false,
                    },
                    twofaOff:{
                        open:false,
                        loading:false,
                        password:null,
                        success:false
                    },
                    cancel2FA: {
                        open: false
                    }
                },
                loading:false,
                login_histories: [],
                attachmentFile: null,
                codeArr:{
                    code1:'',
                    code2:'',
                    code3:'',
                    code4:'',
                    code5:'',
                    code6:''
                },
                mask:createNumberMask({
                    prefix: '',
                    suffix: '',
                    allowDecimal: false,
                    includeThousandsSeparator: false,
                    thousandsSeparatorSymbol: false,
                    allowLeadingZeroes: true,
                    integerLimit: 1,        
                }),
                hideSetUp:true
            }
        },
        mixins: [validationMixin],
        validations: {
            userProfile: {
                name: {
                    required
                },
                password: {
                    required: false
                },
                repassword: {
                    sameAsPassword: sameAs("password"),
                    required: false
                }
            }
        },
        created () {
            this.setUserData();
            this.loadLoginHistories();
            this.getSecretKey();
        },
        watch: { 
            UserLogin: function(val) {
                this.setUserData();
                this.loadLoginHistories();
            },
            "attachmentFile": function (val) {
                if (val) {
                    if (val.type !== 'image/jpeg' && val.type !== 'image/png' && val.type !== 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }

                    var _this = this;
                    const img = new Image();
                    img.src = URL.createObjectURL(val);

                    let data = {
                        url: {
                            original: URL.createObjectURL(val),
                            medium: URL.createObjectURL(val),
                            thumb: URL.createObjectURL(val)
                        }
                    };
                    
                    if(!this.userProfile.signature_image || !this.userProfile.signature_image.length)
                        this.userProfile.signature_image = [data]
                    else
                        this.userProfile.signature_image[0].url = data.url;
                }
            },
        },
        computed: {
            ...mapGetters({
                UserLogin: 'AuthController/user',
            })
        },
        methods:{
            convertNewLine(str){
                return str.replace(/\n/g, '<br />');
            },
            setUserData() {
                if(this.UserLogin && this.UserLogin.id) {
                    this.$store.dispatch('v2UserController/getUser', this.UserLogin.id)
                        .then(response => { 
                            response.data.data.password = null;
                            response.data.data.repassword = null;
                            this.userProfile = {
                                ...this.userProfile,
                                ...response.data.data
                            };
                        })
                        .catch(error => {})
                }
            },
            save() {
                this.timer = setTimeout(() => {
                    this.$v.userProfile.$touch()
                    if(!this.$v.userProfile.$error){
                        this.errorMessage = null;
                        let request = {
                            id: this.userProfile.id,
                            name: this.userProfile.name,
                            password: this.userProfile.password,
                            organisation_id: this.userProfile.organisation_id,
                            email: this.userProfile.email,
                            contract_id: this.userProfile.contract_id,
                            property_id: this.userProfile.property_id,
                            preferred_contact_mode: this.userProfile.preferred_contact_mode,
                            mailing_address_id: this.userProfile.mailing_address_id,
                            mailing_address_id_tmp: this.userProfile.mailing_address_id,
                            billing_address_id: this.userProfile.billing_address_id,
                            billing_address_id_tmp: this.userProfile.billing_address_id_tmp,
                            last_change_pwd_at: this.userProfile.last_change_pwd_at,
                            department: this.userProfile.department,
                            active: this.userProfile.active,
                            role: this.userProfile.roles,
                            microsoft2fa_enable: this.userProfile.microsoft2fa_enable,
                        }
                        request.attachment_id = null
                        request.attachment = this.attachmentFile
                        if(this.userProfile.signature_image && this.userProfile.signature_image[0] && this.userProfile.signature_image[0].id) {
                            request.attachment_id = this.userProfile.signature_image[0].id
                        }
                        this.$store.dispatch(`v2UserController/updateUser`, request)
                        .then(async response => {
                            if(response.code == 400){
                                if(response.data){
                                    this.errorMessage = this.convertNewLine(response.message);
                                    this.$bvToast.show('toast-custom1');
                                }else{  
                                    this.$alertNotification(response.message, "danger");
                                }
                                this.disabled = false;
                                return;
                            }
                            this.disabled = false
                            this.setUserData()
                            await this.$alertNotification(this.$notificationV2('editing', 'user'));
                        })
                        .catch(error => {
                            this.disabled = false
                            if(error.error.message.password) {
                                this.$alertNotification(error.error.message.password[0], "danger");
                            }
                            if(error.error.message.email) {
                                this.$alertNotification(error.error.message.email[0], "danger");
                            }
                        })
                    }
                }, 300)
            },
            async logout() {
                if(goFix){
                    await  goFix._logout();
                }else{
                    this.$store.dispatch('AuthController/logout')
                        .then(result => {
                            this.$store.reset();
                            this.$router.push(`/login`)
                        })
                        .catch(error => {
                            this.$router.push(`/login`)
                        })
                }
            },
          async loadLoginHistories(){
            if(!this.UserLogin || !this.UserLogin.id) return;
            let tableRequest = {
              limit: 10,
              page: 1,
              isCMS: 1,
              sortColumn: "created_at",
              sortDirection: "DESC",
              filter: {
                user_id: {
                  type: "number",
                  value: this.UserLogin.id,
                  function: "=",
                  with: []
                }
              }
            }
            this.modals.last_login.loading = true;
            await this.$store.dispatch("AuditTrailController/getUserActivityLogs", tableRequest)
                .then(response => {
                  this.login_histories = response.items;
                  this.tableConfig.total = response.total;
                  this.modals.last_login.loading = false;
                })
                .catch(err => {
                  this.modals.last_login.loading = false;
                })
            },
            focusNext(e){
                const inputs = Array.from(e.target.form.querySelectorAll('input[type="text"]'));
                const index = inputs.indexOf(e.target);
                if(e.target.value){
                    if (index < (inputs.length - 1)) {
                        inputs[index + 1].focus();
                    }
                }else{
                    if (index > 0) {
                        inputs[index - 1].focus();
                    }
                }
            },
            continueStep(){
                this.modals.step1 = false;
                this.modals.step2 = true;
                this.modals.step3 = false;
                //
                let request = {
                    email:this.UserLogin.email,
                    mfa_secret_key: this.modals.twofa.data.secret
                };
                this.$store.dispatch(`AuthController/updateSecretKey`, request);
            },
            resetModal(){
                if(this.modals.step1 == true || this.modals.step2 == true){
                    this.userProfile.microsoft2fa_enable = false;
                }
                this.modals.step1 = true;
                this.modals.step2 = false;
                this.modals.step3 = false;
                this.codeArr = {
                    code1:'',
                    code2:'',
                    code3:'',
                    code4:'',
                    code5:'',
                    code6:''
                };
            },
            async getSecretKey(){
                this.hideSetUp = true;
                let user = JSON.parse(localStorage.getItem('user_info'));
                let params = {
                    email: user.email
                };
                this.$store.dispatch( 'AuthController/getMFASecretKey', params)
                .then(async response =>{
                    if(!response || (response && !response.mfa_secret_key)){
                        this.hideSetUp = false;
                    }
                })
                .catch(error=>{
                    this.hideSetUp = true;
                })
            },
            async verifyCode(){
                this.modals.step1 = false;
                let code = '';
                let codeArr  = this.codeArr;
                for(let el in codeArr){
                    if(codeArr[el]){
                        code += codeArr[el];
                    }
                }
                if(code.length < 6){
                    return this.$alertNotification("Please fill code with 6 digits!", "danger");
                }
                this.modals.twofa.loading = true;
                this.loading = true;
                let params = {
                    microsoft2fa_secret: this.modals.twofa.data.secret,
                    code:code
                }
                this.$store.dispatch( 'AuthController/verifyCode', params)
                .then(async response =>{
                    this.modals.twofa.loading = false;
                    this.modals.step2 = false;
                    this.modals.step3 = true;
                    this.loading = false;
                })
                .catch(error=>{
                    this.modals.twofa.loading = false;
                    this.loading = false;
                    return this.$alertNotification(error.response.data.error.message, 'danger');
                   
                })
            },
            getQRCode(){
                this.loading = true;
                this.$store.dispatch( 'AuthController/getQRCode', null)
                .then(async response =>{
                    this.modals.twofa.data = response.data;
                    this.loading = false;
                })
                .catch(error=>{
                    this.loading = false;
                })
            },
            done(){
                this.modals.twofa.open = false;
            },
            disableTwoFA(){
                this.modals.twofaConfirm.open = false;
                this.modals.twofaOff.open = true;
                this.modals.twofaOff.password = null;
            },
            cancelDisableTwoFA(){
                this.modals.twofaConfirm.open = false;
                this.userProfile.microsoft2fa_enable = true;
            },
            msAuthentication(val){
                if(val == true){
                    this.modals.twofa.open = true
                    if(this.hideSetUp){
                        this.modals.step2 = true;
                        this.modals.step1 = false;
                        return;
                    }
                    //this.modals.twofa.open = true;
                    this.getQRCode();
                    return;
                }
                this.modals.twofaConfirm.open = true;
            },
            submitDisableTwoFA(){
                let password = this.modals.twofaOff.password;
                if(!password){
                    return this.$alertNotification("Please fill password!", "danger");
                }
                this.modals.twofaOff.loading = true;
                this.$store.dispatch( 'AuthController/disableTwoFA', {password:password})
                .then(async response =>{
                    this.modals.twofaOff.loading = false;
                    this.modals.twofaOff.open = false;
                    this.modals.twofaOff.success = true;
                    this.userProfile.microsoft2fa_secret = null;
                    return this.$alertNotification(response.data.data.message, 'success');
                })
                .catch(error=>{
                    this.modals.twofaOff.loading = false;
                    return this.$alertNotification(error.response.data.error.message, 'danger');
                })
            },
            resetModalPW(){
                this.modals.twofaConfirm.open = false;
                if(!this.modals.twofaOff.success){
                    this.userProfile.microsoft2fa_enable = true;
                }
                this.modals.twofaOff.success = false;
            },
            close2FA() {
                this.modals.cancel2FA.open = true;
            },
            cancelSetup2FA() {
                this.modals.twofa.open = false;
                this.modals.cancel2FA.open = false;
            }
        }
    }
</script>
